import React from 'react'
import CopyButton from './CopyButton'
import '../composition-card/team-rank.css'
import { useLanguage } from '../../i18n/LanguageContext'

const PLAY_STYLE_KEYS = {
  Standard: 'filter.standard',
  'Fast 8': 'filter.fast8',
  'Fast 9': 'filter.fast9',
  'Slow Roll (5)': 'filter.slowRoll5',
  'Slow Roll (6)': 'filter.slowRoll6',
  'Slow Roll (7)': 'filter.slowRoll7',
}

function CompositionHeader({
  tier,
  name,
  playStyle,
  code,
  copiedCode,
  handleCopy,
}) {
  const { t } = useLanguage()
  const getTierClass = (tier) => `team-rank tier-${tier.toLowerCase()}`

  return (
    <div className="composition-header">
      <div className="composition-title">
        <div className={getTierClass(tier)}>{tier}</div>
        <h2>{name}</h2>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <div className="composition-play-style">
          {PLAY_STYLE_KEYS[playStyle]
            ? t(PLAY_STYLE_KEYS[playStyle])
            : playStyle}
        </div>
        <CopyButton
          code={code}
          copiedCode={copiedCode}
          handleCopy={handleCopy}
        />
      </div>
    </div>
  )
}

export default CompositionHeader
